// Generated by purs version 0.14.3
"use strict";
var AnyAll_Types = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/src/AnyAll/Types.purs");
var Control_Applicative = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/prelude/v5.0.1/src/Control/Applicative.purs");
var Control_Bind = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/prelude/v5.0.1/src/Control/Bind.purs");
var Control_Category = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/prelude/v5.0.1/src/Control/Category.purs");
var Data_Boolean = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/prelude/v5.0.1/src/Data/Boolean.purs");
var Data_Either = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/either/v5.0.0/src/Data/Either.purs");
var Data_Eq = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/prelude/v5.0.1/src/Data/Eq.purs");
var Data_Foldable = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/foldable-traversable/v5.0.1/src/Data/Foldable.purs");
var Data_Functor = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/prelude/v5.0.1/src/Data/Functor.purs");
var Data_HeytingAlgebra = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/prelude/v5.0.1/src/Data/HeytingAlgebra.purs");
var Data_Map = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/ordered-collections/v2.0.1/src/Data/Map.purs");
var Data_Map_Internal = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/ordered-collections/v2.0.1/src/Data/Map/Internal.purs");
var Data_Maybe = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/maybe/v5.0.0/src/Data/Maybe.purs");
var Data_Ord = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/prelude/v5.0.1/src/Data/Ord.purs");
var Data_Set = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/ordered-collections/v2.0.1/src/Data/Set.purs");
var Data_Tuple = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/tuples/v6.0.1/src/Data/Tuple.purs");
var Data_Unfoldable = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/unfoldable/v5.0.0/src/Data/Unfoldable.purs");
var lookupMarking = function (node) {
    return function (marking) {
        return Data_Maybe.fromMaybe(AnyAll_Types.Default(new Data_Either.Left(Data_Maybe.Nothing.value)))(Data_Map_Internal.lookup(Data_Ord.ordString)(node)(AnyAll_Types.getMarking(marking)));
    };
};
var evaluateAny = function (dictFoldable) {
    return function (items) {
        if (Data_Foldable.elem(dictFoldable)(Data_Maybe.eqMaybe(Data_Eq.eqBoolean))(new Data_Maybe.Just(true))(items)) {
            return new Data_Maybe.Just(true);
        };
        if (Data_Foldable.all(dictFoldable)(Data_HeytingAlgebra.heytingAlgebraBoolean)(function (v) {
            return Data_Eq.eq(Data_Maybe.eqMaybe(Data_Eq.eqBoolean))(v)(new Data_Maybe.Just(false));
        })(items)) {
            return new Data_Maybe.Just(false);
        };
        if (Data_Boolean.otherwise) {
            return Data_Maybe.Nothing.value;
        };
        throw new Error("Failed pattern match at AnyAll.Relevance (line 77, column 1 - line 77, column 68): " + [ items.constructor.name ]);
    };
};
var evaluateAll = function (dictFoldable) {
    return function (items) {
        if (Data_Foldable.all(dictFoldable)(Data_HeytingAlgebra.heytingAlgebraBoolean)(function (v) {
            return Data_Eq.eq(Data_Maybe.eqMaybe(Data_Eq.eqBoolean))(v)(new Data_Maybe.Just(true));
        })(items)) {
            return new Data_Maybe.Just(true);
        };
        if (Data_Foldable.elem(dictFoldable)(Data_Maybe.eqMaybe(Data_Eq.eqBoolean))(new Data_Maybe.Just(false))(items)) {
            return new Data_Maybe.Just(false);
        };
        if (Data_Boolean.otherwise) {
            return Data_Maybe.Nothing.value;
        };
        throw new Error("Failed pattern match at AnyAll.Relevance (line 83, column 1 - line 83, column 68): " + [ items.constructor.name ]);
    };
};
var evaluate = function (v) {
    return function (v1) {
        return function (v2) {
            if (v instanceof AnyAll_Types.Soft && v2 instanceof AnyAll_Types.Leaf) {
                var v3 = Data_Map_Internal.lookup(Data_Ord.ordString)(v2.value0)(v1);
                if (v3 instanceof Data_Maybe.Just && (v3.value0 instanceof Data_Either.Right && v3.value0.value0 instanceof Data_Maybe.Just)) {
                    return new Data_Maybe.Just(v3.value0.value0.value0);
                };
                if (v3 instanceof Data_Maybe.Just && (v3.value0 instanceof Data_Either.Left && v3.value0.value0 instanceof Data_Maybe.Just)) {
                    return new Data_Maybe.Just(v3.value0.value0.value0);
                };
                return Data_Maybe.Nothing.value;
            };
            if (v instanceof AnyAll_Types.Hard && v2 instanceof AnyAll_Types.Leaf) {
                var v3 = Data_Map_Internal.lookup(Data_Ord.ordString)(v2.value0)(v1);
                if (v3 instanceof Data_Maybe.Just && (v3.value0 instanceof Data_Either.Right && v3.value0.value0 instanceof Data_Maybe.Just)) {
                    return new Data_Maybe.Just(v3.value0.value0.value0);
                };
                return Data_Maybe.Nothing.value;
            };
            if (v2 instanceof AnyAll_Types.Not) {
                return Data_Functor.map(Data_Maybe.functorMaybe)(Data_HeytingAlgebra.not(Data_HeytingAlgebra.heytingAlgebraBoolean))(evaluate(v)(v1)(v2.value0));
            };
            if (v2 instanceof AnyAll_Types.Any) {
                return evaluateAny(Data_Foldable.foldableArray)(Data_Functor.map(Data_Functor.functorArray)(evaluate(v)(v1))(v2.value1));
            };
            if (v2 instanceof AnyAll_Types.All) {
                return evaluateAll(Data_Foldable.foldableArray)(Data_Functor.map(Data_Functor.functorArray)(evaluate(v)(v1))(v2.value1));
            };
            throw new Error("Failed pattern match at AnyAll.Relevance (line 64, column 1 - line 64, column 61): " + [ v.constructor.name, v1.constructor.name, v2.constructor.name ]);
        };
    };
};
var relevant = function (sh) {
    return function (dp) {
        return function (marking) {
            return function (parentValue) {
                return function (nl) {
                    return function (self) {
                        var nlMap = function (word) {
                            return function (nldict) {
                                var langs = Data_Set.toUnfoldable(Data_Unfoldable.unfoldableArray)(Data_Map.keys(nldict));
                                return Data_Map_Internal.fromFoldable(Data_Ord.ordString)(Data_Foldable.foldableArray)(Control_Bind.bind(Control_Bind.bindArray)(langs)(function (lg) {
                                    var lgDict = Data_Maybe.fromMaybe(Data_Map_Internal.empty)(Data_Map_Internal.lookup(Data_Ord.ordString)(lg)(nl));
                                    var longtext = Data_Maybe.fromMaybe("")(Data_Map_Internal.lookup(Data_Ord.ordString)(word)(lgDict));
                                    return Control_Applicative.pure(Control_Applicative.applicativeArray)(new Data_Tuple.Tuple(lg, longtext));
                                }));
                            };
                        };
                        var getChildren = function ($copy_v) {
                            var $tco_done = false;
                            var $tco_result;
                            function $tco_loop(v) {
                                if (v instanceof AnyAll_Types.Leaf) {
                                    $tco_done = true;
                                    return [  ];
                                };
                                if (v instanceof AnyAll_Types.Not) {
                                    $copy_v = v.value0;
                                    return;
                                };
                                if (v instanceof AnyAll_Types.Any) {
                                    $tco_done = true;
                                    return v.value1;
                                };
                                if (v instanceof AnyAll_Types.All) {
                                    $tco_done = true;
                                    return v.value1;
                                };
                                throw new Error("Failed pattern match at AnyAll.Relevance (line 50, column 3 - line 50, column 28): " + [ v.constructor.name ]);
                            };
                            while (!$tco_done) {
                                $tco_result = $tco_loop($copy_v);
                            };
                            return $tco_result;
                        };
                        var ask2view = function (v) {
                            if (v instanceof AnyAll_Types.Ask) {
                                return AnyAll_Types.View.value;
                            };
                            return v;
                        };
                        var ask2hide = function (v) {
                            if (v.shouldView instanceof AnyAll_Types.Ask) {
                                return AnyAll_Types.Q({
                                    shouldView: AnyAll_Types.Hide.value,
                                    andOr: v.andOr,
                                    tagNL: v.tagNL,
                                    prePost: v.prePost,
                                    mark: v.mark,
                                    children: v.children
                                });
                            };
                            return v;
                        };
                        var selfValue = evaluate(sh)(marking)(self);
                        var initVis = (function () {
                            var $46 = Data_Maybe.isJust(parentValue);
                            if ($46) {
                                var $47 = Data_Eq.eq(Data_Maybe.eqMaybe(Data_Eq.eqBoolean))(parentValue)(selfValue);
                                if ($47) {
                                    return AnyAll_Types.View.value;
                                };
                                return AnyAll_Types.Hide.value;
                            };
                            var $48 = Data_Maybe.isJust(evaluate(AnyAll_Types.Hard.value)(marking)(self));
                            if ($48) {
                                return AnyAll_Types.View.value;
                            };
                            return AnyAll_Types.Ask.value;
                        })();
                        var paintedChildren = Data_Functor.map(Data_Functor.functorArray)(Data_Functor.map(Data_Functor.functorFn)((function () {
                            var $49 = Data_Eq.notEq(AnyAll_Types.eqShouldView)(initVis)(AnyAll_Types.Hide.value);
                            if ($49) {
                                return Control_Category.identity(Control_Category.categoryFn);
                            };
                            return ask2hide;
                        })())(relevant(sh)(dp)(marking)(selfValue)(nl)))(getChildren(self));
                        var makeQNode = function ($copy_itemNode) {
                            var $tco_done1 = false;
                            var $tco_result;
                            function $tco_loop(itemNode) {
                                if (itemNode instanceof AnyAll_Types.Leaf) {
                                    $tco_done1 = true;
                                    return AnyAll_Types.mkQ(initVis)(new AnyAll_Types.Simply(itemNode.value0))(nlMap(itemNode.value0)(nl))(Data_Maybe.Nothing.value)(lookupMarking(itemNode.value0)(marking))([  ]);
                                };
                                if (itemNode instanceof AnyAll_Types.Not) {
                                    $copy_itemNode = itemNode.value0;
                                    return;
                                };
                                if (itemNode instanceof AnyAll_Types.Any) {
                                    $tco_done1 = true;
                                    return AnyAll_Types.mkQ(ask2view(initVis))(AnyAll_Types.Or.value)(nlMap(AnyAll_Types.label2pre(itemNode.value0))(nl))(new Data_Maybe.Just(itemNode.value0))(AnyAll_Types.Default(new Data_Either.Left(selfValue)))(paintedChildren);
                                };
                                if (itemNode instanceof AnyAll_Types.All) {
                                    $tco_done1 = true;
                                    return AnyAll_Types.mkQ(ask2view(initVis))(AnyAll_Types.And.value)(nlMap(AnyAll_Types.label2pre(itemNode.value0))(nl))(new Data_Maybe.Just(itemNode.value0))(AnyAll_Types.Default(new Data_Either.Left(selfValue)))(paintedChildren);
                                };
                                throw new Error("Failed pattern match at AnyAll.Relevance (line 29, column 26 - line 33, column 137): " + [ itemNode.constructor.name ]);
                            };
                            while (!$tco_done1) {
                                $tco_result = $tco_loop($copy_itemNode);
                            };
                            return $tco_result;
                        };
                        return makeQNode(self);
                    };
                };
            };
        };
    };
};
module.exports = {
    relevant: relevant,
    evaluate: evaluate,
    evaluateAny: evaluateAny,
    evaluateAll: evaluateAll,
    lookupMarking: lookupMarking
};

